﻿$.fn.dxCtrlBuilderEmailStyleFontBoldUnderline = function custom_dxCtrlBuilderEmailStyleFontBoldUnderline (option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylefontunderline dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleFontBoldUnderline (this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleFontBoldUnderline = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        var $Table = $("<table style='width:100%;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;padding-right:5px;vertical-align:middle;'><i class='fas fa-underline' style='font-size:16px'></i></td>").appendTo($Table)
        var $Td = $("<td style='width:100%'/>").appendTo($Table)
        var ds = ["Souligné", "Normal", "Surligné", "Barré"]
        if (option.allowDefaut) ds.unshift("Défaut")
        $("<div/>").appendTo($Td).dxCtrlRadioButton({
            dataSource: ds,
            value: ((option.value == "underline") ? "Souligné" : ((option.value == "none") ? "Normal" : ((option.value == "overline") ? "Surligné" : ((option.value == "line-through") ? "Barré" : "Défaut")))),
            layout: 'horizontal',
            itemTemplate: function (itemData, itemIndex, itemElement) {
                if (itemData == "Défaut") {
                    itemElement.html("<i class='fas fa-text-slash'></i>")
                    itemElement.attr("title", "Utiliser le style par défaut")
                } else {
                    itemElement.text(itemData)
                    itemElement.attr("title", itemData)
                }
            },
            onValueChanged: function (e) {
                var newValue = ""
                switch (e.value) {
                    case "Défaut": newValue = ""; break;
                    case "Souligné": newValue = "underline"; break;
                    case "Normal": newValue = "none"; break;
                    case "Surligné": newValue = "overline"; break;
                    case "Barré": newValue = "line-through"; break;
                }
                option.onValueChanged({ values: [{ prop: "text-decoration", value: newValue, oldValue: option.value }] })
                option.value = newValue
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}